import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "upload-card__header" }
const _hoisted_2 = { class: "upload-card__title" }
const _hoisted_3 = { class: "upload-card__title-text" }
const _hoisted_4 = { class: "upload-card__size" }
const _hoisted_5 = {
  key: 1,
  class: "upload-card__list"
}
const _hoisted_6 = {
  key: 0,
  class: "hr-line"
}

import {ref} from "vue";
import IconChevronBottom from "@/assets/icons/IconChevronBottom.vue";
import UploadFileItem from "@/components/modules/FileUploadModal/UploadFileItem.vue";
import ProgressBar from "@/components/modules/FileUploadModal/ProgressBar.vue";
import IconCheck from "@/assets/icons/IconCheck.vue";
import {FileStatus} from "@/types/files";

interface FileData {
  file_id: string;
  file_name: string;
  file_size: number;
  error: null | string;
  status?: FileStatus;
  progress?: number;
  isUploading?: boolean;
}

interface Props {
  files: FileData[];
  totalSize?: string;
  statusText?: string;
  progress?: number;
  isUploading?: boolean;
  isError?: boolean;
  isFileUploadingComplete?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadCard',
  props: {
    files: {},
    totalSize: { default: "" },
    statusText: { default: "Загрузка завершена" },
    progress: { default: 0 },
    isUploading: { type: Boolean, default: false },
    isError: { type: Boolean },
    isFileUploadingComplete: { type: Boolean, default: false }
  },
  emits: ["retryFile", "deleteFile", "cancelFile"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const isExpanded = ref(false);

const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["upload-card", {'upload-card--expanded': isExpanded.value}])
  }, [
    (__props.files.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(__props.files.length) + " файлов", 1),
              (!__props.isUploading && __props.progress === 100)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "upload-card__title-text" }, " · ", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass([[__props.isError ? 'upload-card__title-text--error' : 'upload-card__title-text--status'], "upload-card__title-text"])
                    }, _toDisplayString(__props.statusText), 3)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["upload-card__toggle", {'upload-card__toggle--active': isExpanded.value}]),
              onClick: toggleExpanded
            }, [
              (!__props.isFileUploadingComplete)
                ? (_openBlock(), _createBlock(IconChevronBottom, { key: 0 }))
                : _createCommentVNode("", true),
              (__props.isFileUploadingComplete)
                ? (_openBlock(), _createBlock(IconCheck, { key: 1 }))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          (!isExpanded.value && __props.totalSize)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(__props.totalSize), 1),
                (__props.isUploading || __props.isFileUploadingComplete)
                  ? (_openBlock(), _createBlock(ProgressBar, {
                      key: 0,
                      progress: __props.progress,
                      "is-uploading": __props.isUploading
                    }, null, 8, ["progress", "is-uploading"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.files, (file, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: file.file_id
                  }, [
                    _createVNode(UploadFileItem, {
                      "file-name": file.file_name,
                      "file-size": file.file_size,
                      error: file.error,
                      status: file.status,
                      progress: file.progress !== undefined ? file.progress : __props.progress,
                      "is-file-uploading-complete": file.isUploading !== undefined ? !file.isUploading && file.progress === 100 : __props.isFileUploadingComplete,
                      onRetry: ($event: any) => (emit('retryFile', file.file_id)),
                      onDelete: ($event: any) => (emit('deleteFile', file.file_id)),
                      onCancel: ($event: any) => (emit('cancelFile', file.file_id))
                    }, null, 8, ["file-name", "file-size", "error", "status", "progress", "is-file-uploading-complete", "onRetry", "onDelete", "onCancel"]),
                    (index !== __props.files.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
        ], 64))
      : (__props.files.length === 1)
        ? (_openBlock(), _createBlock(UploadFileItem, {
            key: 1,
            status: __props.files[0].status,
            progress: __props.files[0].progress !== undefined ? __props.files[0].progress : __props.progress,
            error: __props.files[0].error,
            "file-name": __props.files[0].file_name,
            "file-size": __props.files[0].file_size,
            "is-file-uploading-complete": __props.files[0].isUploading !== undefined ? !__props.files[0].isUploading && __props.files[0].progress === 100 : __props.isFileUploadingComplete,
            onRetry: _cache[0] || (_cache[0] = ($event: any) => (emit('retryFile', __props.files[0].file_id))),
            onDelete: _cache[1] || (_cache[1] = ($event: any) => (emit('deleteFile', __props.files[0].file_id))),
            onCancel: _cache[2] || (_cache[2] = ($event: any) => (emit('cancelFile', __props.files[0].file_id)))
          }, null, 8, ["status", "progress", "error", "file-name", "file-size", "is-file-uploading-complete"]))
        : _createCommentVNode("", true)
  ], 2))
}
}

})